/**
 * Shared label for a run-type badge that renders both variants (run history and run detail): a
 * validation-only run (`dryRun`) is a "Test Run"; a persisted submission is a "Live Run". Surfaces
 * that only ever show one variant, or that decorate the label (e.g. the submit page's "Submit Live
 * Run" button and count tabs), keep their own literals.
 */
export function runTypeLabel(dryRun: boolean): "Test Run" | "Live Run" {
  return dryRun ? "Test Run" : "Live Run"
}
